import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';
import AndroidSvg from 'devicon/icons/android/android-original.svg';

export const Android = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="lang-android" className={cx('sdkIcon', className)} size={size} {...props}>
    <AndroidSvg />
  </LegacyIcon>
);
